import { connect } from 'react-redux';

import { getUserRoles } from 'core/slices/users';

import { getSlackChannels } from 'core/slices/slack_channels';
import { getTeams } from 'core/slices/teams';

import {
  getAchievementsTypes,
  getNotSeenAchievements,
  patchNotSeenAchievements
} from 'core/slices/achievements';

import {
  getRole,
  isLoadingCoverageList,
  isLoadingFindFiles,
  isLoadingGAP,
  isLoadingProjects,
  isLoadingReleaseDates,
  isLoadingReleases,
  isLoadingRole,
  isLoadingScopes,
  isLoadingSlackChannels,
  isLoadingTeams,
  isLoadingUsers,
  selectAchievementsTypes,
  selectIsAchievementsTypesLoading,
  selectIsNotSeenAchievementsLoading,
  selectNotSeenAchievements,
} from 'core/selectors';

import Layout from '../../../components/navbar/Layout';

export default connect(
  state => ({
    userRole: getRole(state),
    isLoadingRole: isLoadingRole(state),
    isLoadingProjects: isLoadingProjects(state),
    isLoadingUsers: isLoadingUsers(state),
    isLoadingScopes: isLoadingScopes(state),
    isLoadingTeams: isLoadingTeams(state),
    isLoadingReleases: isLoadingReleases(state),
    isLoadingSlackChannels: isLoadingSlackChannels(state),
    isLoadingCoverageList: isLoadingCoverageList(state),
    isLoadingReleaseDates: isLoadingReleaseDates(state),
    isLoadingGAP: isLoadingGAP(state),
    isLoadingFindFiles: isLoadingFindFiles(state),
    notSeenAchievements: selectNotSeenAchievements(state),
    isNotSeenAchievementsLoading: selectIsNotSeenAchievementsLoading(state),
    achievementsTypes: selectAchievementsTypes(state),
    isAchievementsTypesLoading: selectIsAchievementsTypesLoading(state),
  }),
  {
    getUserRoles,
    getTeams,
    getSlackChannels,
    getNotSeenAchievements,
    patchNotSeenAchievements,
    getAchievementsTypes,
  },
)(Layout);
